import React from 'react';
import './detallerubro.css';
import { rubros } from '../../json/rubros';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react'; 

const DetalleRubro = () => {
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre === nombre);

  return (
    <div className='container container_detalle_rubro'>
      <div className='row'>
        <div className='col-12'>
          <div className='rubro_titulo'>
            <h3 className='title'>{rubro.nombre}</h3>
            <hr className='hr-gob' />
          </div>
        </div>
      </div>
      <div className='row'>
        {
          rubro.formatos.map((formato, index) => 
          {
            let urlXLSX = '';
            let urlHTML = '';

            if (formato.xlsx != '')
            // {
            //   urlXLSX = "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/a69_" + formato.xlsx + "SIPDUS.xlsx";
            //   urlHTML = "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/transparencia/Art69/htm/a69_" + formato.html + "SIPDUS.htm";
            // }
            {
                urlXLSX = "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/a69_" + formato.xlsx + "SIPDUS.xlsx";
                urlHTML = "https://s-infraestructura.hidalgo.gob.mx/Transparencia/art69/htm/a69_" + formato.html + "SIPDUS.htm";
            }
            else {
              urlXLSX = formato.xlsx_liga;
              urlHTML = formato.htm_liga;
            }

             
            return (
              <div key={ index } className='col-md-4 col-12'>
                <div className='rubro_container_detalle'>
                  <div className='detalle_rubro_nombre'>
                    <h5>{ formato.nombre }</h5>
                  </div>
                  <div className='detalle_rubro_enlaces'>
                    <a className="boton-rubro" href={ urlXLSX } target="_blank">
                        <i className="rubro-icon icon-file-xlsx"></i>
                        XLSX
                    </a>
                    <a className="boton-rubro" href={ urlHTML } target="_blank">
                        <i className="rubro-icon icon-table-htm"></i>
                        Ver Tabla
                    </a>
                  </div>
                </div>
              </div>
            );
          }
          
          
          )
        }
      </div>
    </div>
  );
};

export default DetalleRubro;
